SA.createObject = function(key, value) {
    var obj = {};

    obj[key] = value;

    return obj;
};

Ext.define('SA.Object', {
    statics: {
        filterValues(object, fn) {
            var filteredEntries = Object.entries(object).filter(([, value]) => fn(value));

            return Object.fromEntries(filteredEntries);
        },

        fromKeyValueArrays(keys, values) {
            var entries = keys.map((key, i) => [key, values[i]]);

            return Object.fromEntries(entries);
        },

        isEmpty(object = {}) {
            return !Object.keys(object).length;
        },

        keysAre(object, keys) {
            return SA.Array.equalSets(Object.keys(object), keys);
        },

        mapEntries(object, fn) {
            return Object.fromEntries(Object.entries(object).map(fn));
        },

        mapValues(object, fn) {
            return this.mapEntries(object, ([key, value]) => {
                return [key, fn(value, key)];
            });
        },

        of(value) {
            return Ext.isObject(value) ? new SA.Object(value) : null;
        }
    },

    constructor(object) {
        this.object = object;
    },

    hasType(predicateType) {
        if (Array.isArray(predicateType)) {
            return predicateType.includes(this.property('type'));
        }

        return this.property('type') === predicateType;
    },

    keysAre(keys) {
        return SA.Object.keysAre(this.object, keys);
    },

    property(key) {
        return this.object[key];
    },

    testProperty(key, predicate) {
        return predicate(this.property(key));
    }
});